import React from 'react';

export function validation(formRef:any) {
    if (formRef && formRef?.current) {
        
        if(formRef && formRef?.current?.props?.schema?.properties?.form1 && formRef?.current?.props?.formData != null)
        {
            var nextFlag =  formRef?.current?.props?.schema?.properties?.form1?.required?.filter((val: any) => formRef?.current?.props?.formData[val] == undefined);
            console.log("nextFlag in 1st=",nextFlag);
            console.log("hit here");
            
            if(nextFlag == undefined){
                return true
            }else{
                
                return nextFlag?.length === 0;
            }
        }
        else if (formRef && formRef.current.props?.schema?.items && formRef.current.props?.formData != null) {
            console.log("form ref items", formRef.current.props?.schema?.items);
            console.log("formdata", formRef.current.props?.formData);
        
            const allOfArray = formRef.current.props?.schema?.items?.allOf;
        
            if (allOfArray) {
                const requiredFields = allOfArray.map((item: { required: any; }) => item.required).flat().filter((f:any)=>f != undefined);
                const nextFlag = requiredFields.filter((fieldName: string | number) => formRef.current.props?.formData[formRef.current.props?.formData.length -1][fieldName] === undefined);
                
                console.log("Next flag in 2nd:", nextFlag);
                console.log("Hit here");
                //////////////this is to handle edge case due to added toggle button in swd form/////
                if(nextFlag[0] ==undefined){                                                      //
                        return true;                                                             //  
                };                                                                              // 
                ///////////////////////////////////////////End///////////////////////////////////
                if (nextFlag == undefined) {
                    return true;
                } else {
                    console.log("Next flag length:", nextFlag.length);
                    return nextFlag?.length === 0;
                }
            } else {
                // Handle the case when allOfArray is undefined
                return false; // or true, depending on your requirement
            }
        }
        
        else{
        var nextFlag = formRef?.current?.props?.schema?.required?.filter((val: any) => formRef?.current?.props?.formData[val] == undefined);
        console.log("formRef?.current?.props?.schema?.required=",formRef?.current?.props?.formData);
        
        console.log("nextFlag 3rd=",nextFlag);
        if(nextFlag == undefined){
            return true
        }else{
            console.log("1st flag length",nextFlag.length)
            return nextFlag?.length === 0;
        }
    }
    }
    else{
        var nextFlag = formRef?.current?.props?.schema?.required?.filter((val: any) => formRef?.current?.props?.formData[val] == undefined);
        console.log("nextFlag 4th=",nextFlag);
        console.log("=================",formRef)
        
        if(nextFlag == undefined){
            return true
        }else{
            return nextFlag?.length === 0;
        }
    }
    return false;
}
